export const $gte = (v, gte) => v >= gte

export const $mustBeString = (value) => typeof value === 'string'

export const $mustBeNumber = (value) => typeof value === 'number'
